import { createAction } from '@reduxjs/toolkit';

import {
    ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLICK_SUBMIT,
    ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLICK_LEARN_MORE,
    ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_VIEW_DD_MODAL,
    ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLOSE_DD_MODAL,
    ANALYTICS_CARD_MVP_2_REJECTED_CLICK_SHOP,
    ANALYTICS_CARD_MVP_2_REJECTED_CLICK_DASHBOARD_FOOTER,
    ANALYTICS_CARD_MVP_2_ERROR_CLICK_DONE,
    ANALYTICS_CARD_MVP_2_EMPLOYMENT_REJECTED_CLICK_BACK,
    ANALYTICS_CARD_MVP_2_EMPLOYMENT_REJECTED_CLICK_DASHBOARD_FOOTER,
    ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_FORM,
    ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_INSTRUCTIONS,
    ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_DONE,
    ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_TRY_AGAIN,
    ANALYTICS_CARD_MANUAL_SETUP_MVP_2_PAGE_VIEW,
    ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_FORM,
    ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_INSTRUCTIONS,
    ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_DONE,
    ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_TRY_AGAIN,
    ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_PAGE_VIEW,
    ANALYTICS_CARD_ONBOARDING_UNFREEZE_MVP_2_CLICK_DONE,
    ANALYTICS_CARD_ONBOARDING_UNFREEZE_MVP_2_CLICK_TRY_AGAIN,
} from '@perpay-web/fintech/constants/actionTypes';

export function analyticsCardSelectMinimumPaymentMVP2ClickSubmit(
    amountSelected,
) {
    return {
        type: ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLICK_SUBMIT,
        payload: { amountSelected },
    };
}
export function analyticsCardSelectMinimumPaymentMVP2ClickLearnMore() {
    return {
        type: ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLICK_LEARN_MORE,
    };
}
export function analyticsCardSelectMinimumPaymentMVP2ViewDDModal() {
    return {
        type: ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_VIEW_DD_MODAL,
    };
}
export function analyticsCardSelectMinimumPaymentMVP2CloseDDModal() {
    return {
        type: ANALYTICS_CARD_SELECT_MINIMUM_PAYMENT_MVP_2_CLOSE_DD_MODAL,
    };
}

export function analyticsCardRejectedClickDashboardFooter() {
    return {
        type: ANALYTICS_CARD_MVP_2_REJECTED_CLICK_DASHBOARD_FOOTER,
    };
}

export function analyticsCardRejectedClickShop() {
    return {
        type: ANALYTICS_CARD_MVP_2_REJECTED_CLICK_SHOP,
    };
}

export function analyticsCardErrorClickDone() {
    return {
        type: ANALYTICS_CARD_MVP_2_ERROR_CLICK_DONE,
    };
}

export function analyticsCardEmploymentRejectedClickBack() {
    return {
        type: ANALYTICS_CARD_MVP_2_EMPLOYMENT_REJECTED_CLICK_BACK,
    };
}

export function analyticsCardEmploymentRejectedClickDashboardFooter() {
    return {
        type: ANALYTICS_CARD_MVP_2_EMPLOYMENT_REJECTED_CLICK_DASHBOARD_FOOTER,
    };
}

export function analyticsCardManualSetupMVP2ClickForm(signupFlow) {
    return {
        type: ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_FORM,
        payload: { signupFlow },
    };
}

export function analyticsCardManualSetupMVP2ClickInstructions(signupFlow) {
    return {
        type: ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_INSTRUCTIONS,
        payload: { signupFlow },
    };
}

export function analyticsCardManualSetupMVP2ClickDone(signupFlow) {
    return {
        type: ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_DONE,
        payload: { signupFlow },
    };
}

export function analyticsCardManualSetupMVP2ClickTryAgain(signupFlow) {
    return {
        type: ANALYTICS_CARD_MANUAL_SETUP_MVP_2_CLICK_TRY_AGAIN,
        payload: { signupFlow },
    };
}

export function analyticsCardManualSetupMVP2PageView(signupFlow) {
    return {
        type: ANALYTICS_CARD_MANUAL_SETUP_MVP_2_PAGE_VIEW,
        payload: { signupFlow },
    };
}

export function analyticsCardPinwheelFailureMVP2ClickForm() {
    return {
        type: ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_FORM,
    };
}

export function analyticsCardPinwheelFailureMVP2ClickInstructions() {
    return {
        type: ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_INSTRUCTIONS,
    };
}

export function analyticsCardPinwheelFailureMVP2ClickDone() {
    return {
        type: ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_DONE,
    };
}

export function analyticsCardPinwheelFailureMVP2ClickTryAgain() {
    return {
        type: ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_CLICK_TRY_AGAIN,
    };
}

export function analyticsCardPinwheelFailureMVP2PageView() {
    return {
        type: ANALYTICS_CARD_PINWHEEL_FAILURE_MVP_2_PAGE_VIEW,
    };
}

export function analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickDone() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_UNFREEZE_MVP_2_CLICK_DONE,
    };
}

export function analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickTryAgain() {
    return {
        type: ANALYTICS_CARD_ONBOARDING_UNFREEZE_MVP_2_CLICK_TRY_AGAIN,
    };
}

export const analyticsCardApprovedMVP2ClickInfoModal = createAction(
    'ANALYTICS::CARD::APPROVED_MVP_2::CLICK_INFO_MODAL',
);

export const analyticsCardApprovedMVP2ClickCloseModal = createAction(
    'ANALYTICS::CARD::APPROVED_MVP_2::CLICK_CLOSE_MODAL',
);
